var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavicon = function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "favicon_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".favicon_svg__st1{fill:url(#favicon_svg__SVGID_00000109714411036322257690000016290922319329982345_)}.favicon_svg__st2{fill:url(#favicon_svg__SVGID_00000101105385039400933230000010685641278891651203_)}")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "favicon_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -22.712,
    y1: 442.547,
    x2: 522.916,
    y2: 696.978,
    gradientTransform: "translate(0 -320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    style: {
      stopColor: "#ee4d5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#ffe04a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    style: {
      stopColor: "#ee4d5a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.9 0c52.3.4 86 36.7 92.9 90.7C205.3 210 277.9 278.3 410.5 312c51.4 13 90.3 43.6 89.4 94.2-.9 51-40.6 92-91.2 93.8-54 2.2-89-35-98.5-89-22-125.7-100.2-204.4-222.5-223.4C36.3 179.4-2.2 141.8 0 91.7 2.2 39.3 44.2-.4 96.9 0z",
    style: {
      fill: "url(#favicon_svg__SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "favicon_svg__SVGID_00000109725788836235818050000003298946545125510051_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.925,
    y1: 341.668,
    x2: 335,
    y2: 497.699,
    gradientTransform: "translate(0 -320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#113c73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#2260aa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#49c4d6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#favicon_svg__SVGID_00000109725788836235818050000003298946545125510051_)"
    },
    d: "M404.9 236.8c-21.6-24.6-48.4-53.6-73.9-83.4-32.8-38.5-27.7-94.6 10.8-129.6 36.7-33.3 96.4-31.1 130.5 4.3 35.9 36.7 36.3 92.9 2.2 130.5-24.6 27.2-48.8 54.8-69.6 78.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "favicon_svg__SVGID_00000114040467790911466250000005036860114769301377_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.234,
    y1: 9089.797,
    x2: 26.308,
    y2: 9245.825,
    gradientTransform: "matrix(1 0 0 -1 0 9567.807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#113c73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#2260aa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#49c4d6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#favicon_svg__SVGID_00000114040467790911466250000005036860114769301377_)"
    },
    d: "M96.4 263.1c-21.6 24.6-48.4 53.6-73.9 83.4-32.8 38.5-27.6 94.6 10.9 129.6 36.7 33.3 96.4 31.1 130.5-4.3 35.9-36.7 36.3-92.9 2.2-130.5-24.7-27.2-48.9-54.8-69.7-78.2z"
  }));
};
export { SvgFavicon as ReactComponent };
export default "/auth/login/favicon.svg";